export default function prepareInstanceLink({
  instanceBasePath,
  instanceId
}: {
  instanceBasePath: string;
  instanceId: string | number;
}): string {
  return instanceBasePath.replace("[id]", instanceId.toString());
}
